import { gql } from "@apollo/client";

const STUDENT_UPDATE_PASSWORD = gql`
  mutation StudentUpdatePassword(
    $resetPasswordToken: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    studentUpdatePasswordWithToken(
      resetPasswordToken: $resetPasswordToken
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      authenticatable {
        email
        givenName
        familyName
      }
    }
  }
`;

export default STUDENT_UPDATE_PASSWORD;
